'use client';

import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';

const UrlRedirect = () => {
  const router = useRouter();
  const nextPathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // We use window.location.pathname to catch the raw URL,
    // including any /index.html that the server might have served.
    const currentRawPath = window.location.pathname;
    let targetPath = currentRawPath;

    // 1. Strip /index.html if present
    if (targetPath.endsWith('/index.html')) {
      targetPath = targetPath.replace(/\/index\.html$/, '/');
    } else if (targetPath === '/index.html') {
      targetPath = '/';
    }

    // 2. Enforce trailing slash (matching next.config.js trailingSlash: true)
    // Only for non-file paths
    const isFile = targetPath.split('/').pop()?.includes('.');
    if (targetPath.length > 1 && !targetPath.endsWith('/') && !isFile) {
      targetPath = `${targetPath}/`;
    }

    // 3. Perform redirect only if the path has changed
    // We compare with window.location.pathname to avoid redundant router calls
    if (targetPath !== currentRawPath) {
      // Use window.location.replace for a more "hard" redirect if it's a structural 
      // change like stripping index.html, which helps prevent loops with the server.
      window.location.replace(targetPath);
    }
  }, [nextPathname]); // Re-run when Next.js path changes

  return null;
};

export default UrlRedirect;
